(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["labwell-bundle-options"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('form.lwbundle').forEach(form => {
  const packs = [...form.querySelectorAll('[name="labwell-bundle"]')];
  const plans = [...form.querySelectorAll('[name="labwell-purchase"]')];
  const variantInput = form.querySelector('[data-pack-variant]');
  const planInput = form.querySelector('[data-pack-plan]');
  const button = form.querySelector('.lwbundle-submit');
  const error = form.querySelector('.lwbundle-error');
  const fieldsets = [...form.querySelectorAll('fieldset')];
  const root = window.Shopify?.routes?.root || '/';
  const markerKey = 'labwell-stride-checkout-v2';
  let checkoutMarker = null;
  let submitting = false;
  let resetting = false;
  let resetPromise = Promise.resolve();
  const isSubscription = () => plans.some(plan => plan.checked && plan.value === 'subscription');
  const selectedPack = () => packs.find(pack => pack.checked) || packs[0];
  const canBuy = () => selectedPack()?.dataset.available === 'true' && (!isSubscription() || Boolean(selectedPack().dataset.plan));
  const syncSelection = () => {
    const chosen = selectedPack();
    const subscription = isSubscription();
    const mode = subscription ? 'subscription' : 'once';
    chosen.checked = true;
    plans.forEach(plan => plan.closest('.lwbundle-plan').classList.toggle('is-selected', plan.checked));
    packs.forEach(pack => {
      const card = pack.closest('.lwbundle-card');
      card.classList.toggle('is-selected', pack.checked);
      card.querySelector('[data-pack-daily]').textContent = pack.dataset[`${mode}Daily`];
      const savings = card.querySelector('[data-pack-saving]');
      savings.textContent = pack.dataset[`${mode}Saving`];
      savings.hidden = !subscription && Number(pack.dataset.oncePercent) === 0;
    });
    variantInput.value = chosen.value;
    planInput.value = chosen.dataset.plan || '';
    planInput.disabled = !subscription || !planInput.value;
    form.querySelector('[data-bundle-total]').textContent = chosen.dataset[`${mode}Total`];
    form.querySelector('[data-pack-terms]').textContent = chosen.dataset[`${mode}Terms`];
    form.querySelector('[data-pack-cancel]').hidden = !subscription;
    const delivery = form.querySelector('[data-pack-delivery]');
    delivery.textContent = chosen.dataset.delivery;
    delivery.hidden = !subscription;
    const label = form.querySelector('[data-pack-cta]');
    label.textContent = chosen.dataset.available === 'true' ? form.dataset.cta : form.dataset.soldOut;
    button.disabled = submitting || !canBuy();
    if (subscription && !chosen.dataset.plan) { error.textContent = form.dataset.unavailable; error.hidden = false; }
  };
  const setBusy = busy => {
    submitting = busy;
    button.disabled = busy || !canBuy();
    fieldsets.forEach(fieldset => { fieldset.disabled = busy; });
    if (busy) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  };
  const showError = failure => { error.textContent = failure.message || form.dataset.error; error.hidden = false; };
  const rememberCheckout = () => {
    checkoutMarker = {path: location.pathname, variant: variantInput.value, purchase: isSubscription() ? 'subscription' : 'once'};
    try { sessionStorage.setItem(markerKey, JSON.stringify(checkoutMarker)); } catch (_) {}
    try { history.replaceState({...history.state, labwellStrideCheckout: checkoutMarker}, ''); } catch (_) {}
  };
  const readCheckoutMarker = () => {
    let marker = checkoutMarker || history.state?.labwellStrideCheckout;
    if (!marker) { try { marker = JSON.parse(sessionStorage.getItem(markerKey)); } catch (_) {} }
    return marker?.path === location.pathname ? marker : null;
  };
  const forgetCheckout = () => {
    checkoutMarker = null;
    try { sessionStorage.removeItem(markerKey); sessionStorage.removeItem('labwell-stride-checkout'); } catch (_) {}
    try { const state = {...history.state}; delete state.labwellStrideCheckout; history.replaceState(state, ''); } catch (_) {}
  };
  const postCart = async (url, payload) => {
    const response = await fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(payload)});
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || form.dataset.error);
    return result;
  };
  const clearCart = async () => {
    const cart = await postCart(`${root}cart/clear.js`, {});
    if (cart.item_count !== 0) throw new Error(form.dataset.error);
    document.querySelectorAll('#cart-icon-bubble .cart-count-bubble').forEach(bubble => bubble.remove());
  };
  const restoreAfterCheckout = () => {
    if (resetting) return;
    const marker = readCheckoutMarker();
    if (submitting && !marker) return;
    if (marker) {
      const previous = packs.find(pack => pack.value === marker.variant);
      if (previous) previous.checked = true;
      plans.forEach(plan => { plan.checked = plan.value === marker.purchase; });
      if (!plans.some(plan => plan.checked)) plans[0].checked = true;
    }
    error.hidden = true;
    setBusy(false);
    syncSelection();
    if (!marker) return;
    resetting = true;
    resetPromise = clearCart().then(forgetCheckout).catch(showError).finally(() => { resetting = false; });
  };
  packs.forEach(input => input.addEventListener('change', () => { error.hidden = true; syncSelection(); }));
  plans.forEach(input => input.addEventListener('change', () => {
    if (packs[0]) packs[0].checked = true;
    error.hidden = true;
    syncSelection();
  }));
  window.addEventListener('pageshow', restoreAfterCheckout);
  restoreAfterCheckout();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (submitting || !canBuy()) return;
    syncSelection();
    const item = {id:Number(variantInput.value), quantity:1};
    if (isSubscription()) item.selling_plan = Number(planInput.value);
    setBusy(true);
    error.hidden = true;
    try {
      await resetPromise;
      await clearCart();
      await postCart(form.dataset.cartAddUrl, {items:[item]});
      rememberCheckout();
      location.assign(`${root}checkout`);
    } catch (failure) { forgetCheckout(); showError(failure); setBusy(false); }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["labwell-dispatch-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
  const widgets = [...document.querySelectorAll('[data-lw-dispatch]')];
  if (!widgets.length) return;
  const mstOffset = 7 * 60 * 60 * 1000;
  const day = 24 * 60 * 60 * 1000;
  let timer;
  const update = () => {
    const now = Date.now();
    const mst = new Date(now - mstOffset);
    let cutoff = Date.UTC(mst.getUTCFullYear(), mst.getUTCMonth(), mst.getUTCDate(), 15) + mstOffset;
    const shipsToday = now < cutoff;
    if (!shipsToday) cutoff += day;
    const seconds = Math.max(0, Math.ceil((cutoff - now) / 1000));
    const time = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
    widgets.forEach(widget => {
      if (!widget.isConnected) return;
      const message = shipsToday ? widget.dataset.today : widget.dataset.tomorrow;
      const heading = widget.querySelector('[data-dispatch-message]');
      if (heading.textContent !== message) heading.textContent = message;
      widget.querySelector('[data-dispatch-time]').textContent = time;
      widget.querySelector('[data-dispatch-countdown]').hidden = false;
      widget.querySelector('[data-dispatch-fallback]').hidden = true;
    });
  };
  const resume = () => {
    clearInterval(timer);
    update();
    if (!document.hidden) timer = setInterval(update, 1000);
  };
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('pageshow', resume);
  window.addEventListener('pagehide', () => clearInterval(timer));
  resume();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["labwell-purchase-options"] && !Shopify.designMode) return;
  try {
    (() => {
    const form = document.querySelector('form.lwpo');
    if (!form) return;
    const radios = [...form.querySelectorAll('[name="lwpo-purchase"]')];
    const button = form.querySelector('.lwpo-submit');
    const planInput = form.querySelector('[name="selling_plan"]');
    const availabilityNote = form.querySelector('.lwpo-checkout-note');
    const error = form.querySelector('.lwpo-error');
    const ready = form.dataset.subscriptionReady === 'true';
    const available = form.dataset.available === 'true';
    function update() {
      const subscription = radios.some(radio => radio.checked && radio.value === 'subscription');
      radios.forEach(radio => radio.closest('.lwpo-card').classList.toggle('is-selected', radio.checked));
      button.querySelector('.lwpo-submit-label').textContent = subscription ? form.dataset.subscribeLabel : form.dataset.onetimeLabel;
      button.querySelector('.lwpo-submit-price').textContent = subscription ? form.dataset.subscribePrice : form.dataset.onetimePrice;
      button.disabled = !available || (subscription && !ready);
      planInput.disabled = !subscription || !ready;
      availabilityNote.hidden = !subscription || ready;
      error.hidden = true;
    }
    radios.forEach(radio => radio.addEventListener('change', update));
    update();
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const subscription = radios.some(radio => radio.checked && radio.value === 'subscription');
      if (!available || (subscription && !ready)) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const items = [{ id: Number(form.dataset.variantId), quantity: 1 }];
      if (subscription) {
        items[0].selling_plan = Number(form.dataset.planId);
        items.push({ id: Number(form.dataset.giftId), quantity: 1, properties: { '_labwell_welcome_gift': 'First subscription order only' } });
      }
      try {
        const response = await fetch(form.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || form.dataset.error);
        window.location.assign(form.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || form.dataset.error;
        error.hidden = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["labwell-sticky-stride"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('labwell-sticky-stride')) {
  customElements.define('labwell-sticky-stride', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.form = document.getElementById('lwbb-form');
        this.link = this.querySelector('a');
        this.finalCta = document.querySelector('.lws-final');
        if (!this.form || !this.link || !('IntersectionObserver' in window)) return;
        this.updateVisibility = () => {
          const atFinalCta = this.finalCta && this.finalCta.getBoundingClientRect().top < window.innerHeight;
          this.hidden = this.form.getBoundingClientRect().bottom > 0 || Boolean(atFinalCta);
        };
        this.observer = new IntersectionObserver(this.updateVisibility, { threshold:0 });
        this.observer.observe(this.form);
        if (this.finalCta) this.observer.observe(this.finalCta);
        this.onClick = event => {
          event.preventDefault();
          this.hidden = true;
          const choice = this.form.querySelector('[name="labwell-purchase"]:checked');
          choice?.focus({ preventScroll:true });
          this.form.scrollIntoView({ block:'start', behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.link.addEventListener('click', this.onClick);
        window.addEventListener('pageshow', this.updateVisibility);
        this.updateVisibility();
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.link?.removeEventListener('click', this.onClick);
      if (this.updateVisibility) window.removeEventListener('pageshow', this.updateVisibility);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
